import request from "@/utils/request";

// 获取团队主页
export function getIndex(data) {
  return request({
    method: "post",
    path: "team/index",
    data,
  });
}

// 获取团队统计
export function getStatCount(data) {
  return request({
    method: "post",
    path: "team/getStatCount",
    data,
  });
}

// 获取团队成员列表
export function getUserList(data) {
  return request({
    method: "post",
    path: "team/getUserList",
    data,
  });
}

// 获取待审核列表
export function getApplyList(data) {
  return request({
    method: "post",
    path: "team/getApplyList",
    data,
  });
}

// 同意入队
export function setApplyAgree(data) {
  return request({
    method: "post",
    path: "team/setApplyAgree",
    data,
  });
}

// 拒绝入队
export function setApplyReject(data) {
  return request({
    method: "post",
    path: "team/setApplyReject",
    data,
  });
}

// 移出成员
export function deleteUser(data) {
  return request({
    method: "post",
    path: "team/delete",
    data,
  });
}

// 创建团队
export function create(data) {
  return request({
    method: "post",
    path: "team/create",
    data,
  });
}

// 获取余额列表
export function getBalanceList(data) {
  return request({
    method: "post",
    path: "team/getBalanceList",
    data,
  });
}

// 获取信用金列表
export function getCreditDepositList(data) {
  return request({
    method: "post",
    path: "team/getCreditDepositList",
    data,
  });
}

// 获取订单列表
export function getOrderList(data) {
  return request({
    method: "post",
    path: "team/getOrderList",
    data,
  });
}

// 获取订单详情
export function getOrderDetail(data) {
  return request({
    method: "post",
    path: "team/getOrderDetail",
    data,
  });
}

// 获取还款预览
export function getRepaymentPreview(data) {
  return request({
    method: "post",
    path: "team/getRepaymentPreview",
    data,
  });
}

// 订单审批通过
export function setOrderAgree(data) {
  return request({
    method: "post",
    path: "team/setOrderAgree",
    data,
  });
}

// 订单审批驳回
export function setOrderReject(data) {
  return request({
    method: "post",
    path: "team/setOrderReject",
    data,
  });
}

// 设为管理员
export function setAdmin(data) {
  return request({
    method: "post",
    path: "team/setAdmin",
    data,
  });
}

// 取消管理员
export function cancelAdmin(data) {
  return request({
    method: "post",
    path: "team/cancelAdmin",
    data,
  });
}
